import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog,MAT_DIALOG_DATA,MatDialogRef } from  '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import {CommonService } from 'src/app/Global-Services/common.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { HttpErrorResponse } from '@angular/common/http';

export interface DialogData {
  ID: any;
  ClassName: string;
}


@Component({
  selector: 'app-audit-trail-pop-up',
  templateUrl: './audit-trail-pop-up.component.html',
  styleUrls: ['./audit-trail-pop-up.component.css'],
  standalone: false,
})
export class AuditTrailPopUpComponent implements OnInit {
  AuditrailData: any[] =[];

  constructor(public dialogRef: MatDialogRef<AuditTrailPopUpComponent>, private _router: Router,
    private gservice: CommonService,  private dialog: MatDialog, private status: HTTPStatus,@Inject(MAT_DIALOG_DATA) public _data: DialogData,) { }

  ngOnInit() {
    this.GetAllAuditTrailByID();
  }

  GetAllAuditTrailByID() {
    this.gservice.GetAllAuditTrailByID(this._data.ID, this._data.ClassName).subscribe((data: any) => {

      this.AuditrailData = data.Table;
  },
    (err: HttpErrorResponse) => {
      this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
      });
     this.gservice.RedirectToErrorPage(2);
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

}
